import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  loadCartFromStorage,
  saveCartToStorage,
  clearCartFromStorage
} from '../utils/localCartStorage';

export interface LocalCartItem {
  localId: string;
  variantId: number;
  quantity: number;
  properties: Record<string, string>;
  displayName: string;
  thumbnailUrl?: string;
  priceCents: number;
  compareAtPriceCents?: number;
}

interface LocalCartState {
  items: LocalCartItem[];
}

const initialState: LocalCartState = {
  items: loadCartFromStorage() ?? []
};

export const localCartSlice = createSlice({
  name: 'localCart',
  initialState,
  reducers: {
    addLocalCartItem: (state, action: PayloadAction<LocalCartItem>) => {
      state.items.push(action.payload);
      saveCartToStorage(state.items);
    },
    removeLocalCartItem: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.localId !== action.payload);
      saveCartToStorage(state.items);
    },
    clearLocalCart: state => {
      state.items = [];
      clearCartFromStorage();
    }
  }
});

export const { addLocalCartItem, removeLocalCartItem, clearLocalCart } =
  localCartSlice.actions;

export const selectLocalCartItems = (state: { localCart: LocalCartState }) =>
  state.localCart.items;

export const selectLocalCartCount = (state: { localCart: LocalCartState }) =>
  state.localCart.items.length;

export const selectLocalCartTotalCents = (state: {
  localCart: LocalCartState;
}) => state.localCart.items.reduce((total, item) => total + item.priceCents, 0);
